<template>
	<div class="content">
		<div class="content_head">
			<p>
				<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
					<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
				</select>
				<select v-model="selectShopID" @change="pageIndex=1;getData()"
					v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
					<option v-for="i in  Shop" :value="i.ShopID">{{i.ShopName}}</option>
				</select>

				<input type="text" @keypress.enter="pageIndex=1;getData()" placeholder="请输入查询日期(格式:2021-01-01)"
					class="search" v-model="searchText" />
				<button type="button" class="button " @click="pageIndex=1;getData()" title="点击进行查找">查找</button>
			 
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>课程名称</th>
						<th>类别</th>
						<th>课程费用</th>
						<th>开始时间</th>
						<th>结束时间</th>
						<th>报名人数</th>
						<th>课程封面</th>
						<th>上课老师</th>
						<th>修改</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in ShopSubjects">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.SubjectTitle}}
						</td>
						<td>
							{{i.SubjectName}}
						</td>
						<td>
							{{i.PayMoney | rmb}}
						</td>
						<td>
							{{i.BeginDateTime}}
						</td>
						<td>
							{{i.EndDateTime}}
						</td>
						<td class="red">
							{{i.Count+'/'+ i.ChildCount+'人'}}
						<td style="padding: .2rem;">
							<img style="width: 8rem;height: auto;"
								:src="$store.state.baseURL.replace('/api','')+'subjectImg/' +i.Subjectimg" />
						</td>
						<td>
							{{i.UserName}}
						</td>


						<td>
							<button type="button" @click="$router.replace('/SubjectSignUpDetail/'+i.ShopSubjectID)" title="点击开始报名" class="button">开始报名</button>

						</td>
					</tr>
				</tbody>
			</table>
		</div>
		 


	</div>

</template>

<script>
	import j from './shopSubjectSignUp.js'
	export default j
</script>

<style>
</style>
